import { execAdmin } from '@src/apis/reware/utils';
import type {
  CreatePricingRuleMutation,
  CreatePricingRuleMutationVariables,
} from '@src/types/__generated/rewareAdminTypes';

const gql = String.raw;

export const createPricingRule = async ({
  partnerId,
  pricingType,
  rule,
}: CreatePricingRuleMutationVariables) => {
  const query = gql`
    mutation createPricingRule(
      $partnerId: Int!
      $pricingType: String!
      $rule: PricingRuleInput!
    ) {
      partner(id: $partnerId) {
        createPricingRule(
          pricingType: $pricingType
          rule: $rule
        ) {
          id
          position
          condition
          department
          category
          merchantCategory
          tag
          name
          secondaryTag
          secondaryName
          tertiaryTag
          tertiaryName
          discount
          sourceColumn
          upc
        }
      }
    }
  `;

  const data = await execAdmin<CreatePricingRuleMutationVariables, CreatePricingRuleMutation>(
    query,
    { variables: { partnerId, pricingType, rule } }
  );

  const result = data.partner?.createPricingRule;
  if (!result) {
    throw new Error(
      `createPricingRule: unexpected response — partner.createPricingRule is ${result === null ? 'null' : 'undefined'} (partnerId=${partnerId}, pricingType=${pricingType})`
    );
  }
  return result;
};
